import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const ModalVipStyle = {
  modal: () => css`
    .ant-modal {
      width: 914px !important;
      &-content {
        height: 760px !important;
        padding: unset !important;

        ${media.xxl} {
          height: 635px;

          top: 15px;
        }
        .ant-modal-close {
          top: -20px;
          right: -25px;

          background-color: white;
          border-radius: 50%;
          color: black !important;
        }
      }
    }
    h1 {
      color: #8b5211;
      font-size: 30px;
      font-weight: bold;

      text-align: center;

      padding-top: 20px;
      padding-bottom: 10px;
    }
  `,

  wrapper: css`
    overflow-y: scroll;
    height: 760px;
  `,

  self: css`
    display: flex;
    padding: 0 40px;

    margin-bottom: 40px;

    table {
      width: 100%;
      margin: 0 auto;

      border-collapse: collapse;
      border-spacing: 0;

      thead {
        th {
          border-left: 1px dotted #8b5211;
          color: #8b5211;
          font-size: 14px;
          font-weight: bold;
          text-align: center;
          width: max-content;
        }
        tr {
          height: 50px;
          border: 1px solid #f1da6f;
          background-image: linear-gradient(to bottom, #ffe980, #f1da6f);
        }
      }
      tbody {
        text-align: center;
        tr {
          td {
            height: 50px;
            border: 1px solid #f1da6f;
            img {
              width: 40px;
              height: 40px;
              object-fit: contain;
            }
          }
        }
      }
    }
  `,
};
